module.exports = __webpack_public_path__ + "static/media/megaphone.c9944ed6.svg";